import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  TableCell,
  TableRow,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import PageTitle from "../../../../../components/pageTitle/PageTitle";
import TableDesign, {
  TableHeading,
} from "../../../../../components/common/table/TableDesign";
import { useSelector } from "react-redux";
import {
  deleteStaffAbsenceAction,
  getAllStaffAbsenceAction,
  setAddStaffAbsenceAction,
  setDeleteStaffAbsenceAction,
} from "../../../../../store/reducers/assignWorkerSlice";
import deleteIcon from "../../../../../assets/trash.png";
import editIcon from "../../../../../assets/svg/edit_icon.svg";
import dayjs from "dayjs";
import ManageAbsence from "./ManageAbsence";
import DeleteAlert from "../../../../../components/common/DeleteAlert";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import ManageStaff from "./ManageStaff";

interface FilterOption {
  worker_id?: string;
  page: number;
  limit: number;
  orderBy: string;
  orderIn: string;
  search: string;
  start_date?: string;
  end_date?: string;
}

interface AbsenceListProps {
  setSelectedId?: any;
  selectedId?: any;
}

const AbsenceList: React.FC<AbsenceListProps> = ({
  setSelectedId,
  selectedId,
}) => {
  const dispatch = useDispatch();
  const today = dayjs().format("YYYY-MM-DD");
  const { userProfile } = useSelector((state: any) => state?.user);
  const [open, setOpen] = useState(false); // State variable to manage dialog open/close
  const [deleteModelShow, setDeleteModelShow] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState<any | null>(null);
  const {
    addStaffAbsenceResponse,
    staffAbsences,
    deleteStaffAbsenceResponse,
    singleOperationStaff,
  } = useSelector((state: any) => state.assignWorker);
  const tableHeadings: TableHeading[] = [
    { label: "#", align: "left" },
    { label: "Reason", align: "left" },
    { label: "Start", align: "left" },
    { label: "End", align: "left" },
    { label: "Notification", align: "left" },
    { label: "Authorised", align: "left" },
    { label: "Action", align: "center" },
  ];

  const [filterOption, setFilterOption] = useState<FilterOption>({
    page: 1,
    limit: 10,
    orderBy: "created_at",
    orderIn: "DESC",
    search: "",
    worker_id: selectedId ? selectedId : "",
    start_date: today,
    end_date: today,
  });

  useEffect(() => {
    if (selectedId) {
      dispatch(
        getAllStaffAbsenceAction({ ...filterOption, worker_id: selectedId }),
      );
    }
  }, [dispatch, filterOption, selectedId]);

  useEffect(() => {
    if (addStaffAbsenceResponse || deleteStaffAbsenceResponse) {
      setFilterOption((prev: any) => {
        const updated = {
          ...prev,
          worker_id: selectedId,
          start_date: null,
          end_date: null,
        };

        dispatch(getAllStaffAbsenceAction(updated));
        return updated;
      });
      dispatch(setAddStaffAbsenceAction(false));
      dispatch(setDeleteStaffAbsenceAction(false));
      setOpen(false);
      setDeleteModelShow(false);
      setSelectedRowId(null);
    }
  }, [addStaffAbsenceResponse, deleteStaffAbsenceResponse]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleDelete = () => {
    if (selectedRowId) {
      dispatch(deleteStaffAbsenceAction(selectedRowId));
    }
  };

  const handleCloseModel = () => {
    setOpen(false);
    setSelectedRowId(null);
  };

   // Date change handlers
  const handleStartDateChange = (newValue: any) => {
    if (!newValue) return;
    setFilterOption({
      ...filterOption,
      start_date: newValue.format("YYYY-MM-DD"),
    });
  };

  const handleEndDateChange = (newValue: any) => {
    if (!newValue) return;
    setFilterOption({
      ...filterOption,
      end_date: newValue.format("YYYY-MM-DD"),
    });
  };

  return (
    <>
      {deleteModelShow && (
        <DeleteAlert
          alertModalShow={deleteModelShow}
          onConfirm={() => {
            handleDelete();
          }}
          message={"Are you sure you want to delete this absence record?"}
          setAlertModelShow={setDeleteModelShow}
        />
      )}
      {open && (
        <ManageAbsence
          open={open}
          onHide={() => handleCloseModel()}
          title="Manage Worker Absence"
          selectedStaff={selectedId}
          selectedAbsenceId={selectedRowId}
          action={selectedRowId ? "edit" : "add"}
          setSelectedStaff={setSelectedRowId}
        />
      )}
      <Grid container sx={{ height: "100%", marginTop: "10px" }}>
        <Grid
          item
          md={12}
          xs={12}
          id="userList"
          sx={{
            height: "100%",
            border: "1px solid #CFCFCF",
            borderRadius: "5px",
            padding: "8px",
            overflow: "hidden",
          }}
        >
          <PageTitle
            title="Worker Absence"
            button={!singleOperationStaff?.is_deleted ? "Add" : null}
            onClick={handleOpen}
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={!filterOption.start_date && !filterOption.end_date}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setFilterOption({
                        ...filterOption,
                        search: "booked",
                        start_date: "",
                        end_date: "",
                      });
                    } else {
                      const today = dayjs().format("YYYY-MM-DD");
                      setFilterOption({
                        ...filterOption,
                        search: "",
                        start_date: today,
                        end_date: today,
                      });
                    }
                  }}
                />
              }
              label="Show All" // 👈 visible label
            />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Start Date"
                value={
                  filterOption.start_date
                    ? dayjs(filterOption.start_date)
                    : null
                }
                onChange={(newValue) => {
                  if (!newValue) return;

                  handleStartDateChange(newValue);
                }}
                format={userProfile?.dateFormat || "DD/MM/YYYY"}
                slotProps={{
                  textField: {
                    size: "small",
                    sx: {
                      marginRight:'6px',
                      width: 160,
                      "& .MuiInputBase-root": {
                        height: 32,
                        fontSize: 13,
                      },
                      "& .MuiInputLabel-root": {
                        fontSize: 13,
                      },
                    },
                  },
                }}
              />
              <DatePicker
                label="End Date"
                value={
                  filterOption.end_date
                    ? dayjs(filterOption.end_date)
                    : null
                }
                onChange={(newValue) => {
                  if (!newValue) return;

                  handleEndDateChange(newValue);
                }}
                format={userProfile?.dateFormat || "DD/MM/YYYY"}
                slotProps={{
                  textField: {
                    size: "small",
                    sx: {
                      width: 160,
                      "& .MuiInputBase-root": {
                        height: 32,
                        fontSize: 13,
                      },
                      "& .MuiInputLabel-root": {
                        fontSize: 13,
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider>
           
          </Box>
          <TableDesign
            tableHeadings={tableHeadings}
            pagination={{ totalPages: 1, currentPage: 1 }}
            filterOption={filterOption}
            stickyHeader={true}
            setFilterOption={setFilterOption}
            tableHeadColor="#E5F4F1"
            extraCSS={{
              height: "calc(100% - 100px)",
            }}
          >
            {staffAbsences.length > 0 ? (
              staffAbsences.map((val: any, idx: number) => (
                <TableRow
                  key={val?.id}
                  // onClick={() => setSelectedId(val?.id)}
                  sx={{
                    cursor: "pointer",
                    marginTop: "10px",
                    padding: "4px !important",
                    borderRadius: "20px !important",
                    backgroundColor:
                      selectedId === val?.id ? "#f0f0f0" : "transparent", // ✅ active row bg
                    "&:hover": {
                      backgroundColor: "#f0f0f0",
                      outline: "2px solid #f0f0f0",
                      borderRadius: "0px !important",
                      outlineOffset: "-2px !important",
                    },
                  }}
                >
                  <TableCell align="left">{idx + 1}</TableCell>
                  <TableCell>{val?.reason}</TableCell>
                  <TableCell>
                    {val?.start_date
                      ? dayjs(val?.start_date).format(
                          userProfile?.dateFormat
                            ? userProfile?.dateFormat
                            : "DD/MM/YYYY",
                        )
                      : null}
                  </TableCell>
                  <TableCell>
                    {val?.end_date
                      ? dayjs(val?.end_date).format(
                          userProfile?.dateFormat
                            ? userProfile?.dateFormat
                            : "DD/MM/YYYY",
                        )
                      : null}
                  </TableCell>
                  <TableCell>
                    {val?.notified_date
                      ? dayjs(val?.notified_date).format(
                          userProfile?.dateFormat
                            ? userProfile?.dateFormat
                            : "DD/MM/YYYY",
                        )
                      : null}
                  </TableCell>
                  <TableCell>{val?.authorised_by}</TableCell>
                  <TableCell align="center">
                    {!singleOperationStaff?.is_deleted && (
                      <>
                        <img
                          onClick={() => {
                            setSelectedRowId(val?.id);
                            setOpen(true);
                          }}
                          src={editIcon}
                          style={{
                            height: "20px",
                            width: "20px",
                            cursor: "pointer",
                            marginRight: "10px",
                          }}
                          alt="delete"
                        />
                        <img
                          onClick={() => {
                            setSelectedRowId(val?.id);
                            setDeleteModelShow(true);
                          }}
                          src={deleteIcon}
                          style={{
                            height: "20px",
                            width: "20px",
                            cursor: "pointer",
                          }}
                          alt="delete"
                        />
                      </>
                    )}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  No Absence found.
                </TableCell>
              </TableRow>
            )}
          </TableDesign>
        </Grid>
      </Grid>
    </>
  );
};
export default AbsenceList;
